import { message } from 'antd';
import React, { useEffect, useState } from 'react';

import { AuthModalLabelsT, AuthViewT } from '../AuthModal.types';
import { useAuthContext } from '../context/AuthContext';
import { LoadingView } from './LoadingView';
import { AnotherWayView } from './Login/AnotherWayView';
import { LoginEmailView } from './Login/LoginEmailView';
import { LoginPasswordView } from './Login/LoginPasswordView';
import { SignupCodeView } from './Signup/SignupCodeView';
import { SignupEmailView } from './Signup/SignupEmailView';
import { SignupNameView } from './Signup/SignupNameView';
import { SignupPasswordView } from './Signup/SignupPasswordView';

export type LoginFlowPropsT = {
  initView: AuthViewT;
  onClose: () => void;
  onLogin: (token: string) => void;
  labels: AuthModalLabelsT;
  isDesygnerUser?: boolean;
};

export const AuthFlow = ({ ...props }: LoginFlowPropsT) => {
  const [view, setView] = useState<AuthViewT | null | undefined>(props.initView);

  const { serverError, isLoadingView } = useAuthContext();
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (!serverError) return;

    return messageApi.open({
      type: 'error',
      content: serverError,
      duration: 5,
    });
  }, [serverError, messageApi]);

  const handleChangeView = (newView?: AuthViewT) => {
    setView(newView);
  };

  const renderView = () => {
    switch (view) {
      case 'loginEmail':
        return (
          <LoginEmailView
            onChangeView={handleChangeView}
            labels={props.labels.login.emailView}
            onClose={props.onClose}
          />
        );
      case 'loginPassword':
        return (
          <LoginPasswordView
            onChangeView={handleChangeView}
            labels={props.labels.login.passwordView}
            onLogin={props.onLogin}
            onClose={props.onClose}
            isDesygnerUser={props.isDesygnerUser}
          />
        );
      case 'anotherWay':
        return (
          <AnotherWayView labels={props.labels.login.anotherWay} onChangeView={handleChangeView} />
        );

      case 'signupEmail':
        return (
          <SignupEmailView
            labels={props.labels.signup.emailView}
            onChangeView={handleChangeView}
            onClose={props.onClose}
          />
        );

      case 'signupCode':
        return (
          <SignupCodeView
            labels={props.labels.signup.codeView}
            onChangeView={handleChangeView}
            onClose={props.onClose}
          />
        );

      case 'signupPassword':
        return (
          <SignupPasswordView
            labels={props.labels.signup.passwordView}
            onChangeView={handleChangeView}
          />
        );

      case 'signupName':
        return (
          <SignupNameView
            onChangeView={handleChangeView}
            labels={props.labels.signup.nameView}
            onLogin={props.onLogin}
            onClose={props.onClose}
            isDesygnerUser={props.isDesygnerUser}
          />
        );

      default:
        return <div>This view is not yet implemented</div>;
    }
  };

  return (
    <>
      {contextHolder}
      {isLoadingView ? <LoadingView labels={props.labels.loading} /> : renderView()}
    </>
  );
};
